import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Message } from 'primereact/message';
import { Divider } from 'primereact/divider';

const Home = ({ message }) => {
  const { user } = useAuth();

  if (message) {
    return <Message severity="error" text={message} className="flex mt-2 px-3" />;
  }

  const iconColors = [
    { bg: '#ffe0e6', color: '#e91e63' },
    { bg: '#e0f0ff', color: '#2196f3' },
    { bg: '#fff3e0', color: '#ff9800' },
    { bg: '#e8f5e9', color: '#4caf50' },
    { bg: '#f3e5f5', color: '#9c27b0' },
    { bg: '#e0f7fa', color: '#00bcd4' },
  ];

  const isAdmin = user?.isAdmin;
  const hasAccess = (path) => isAdmin || user?.allowedPaths?.includes(path);

  const menuCategories = [
    {
      title: 'Запросы',
      items: [
        { label: 'Приграничные абоненты', description: 'Просмотр данных о приграничных абонентах', icon: 'pi pi-users', path: '/border-subs' },
        { label: 'Местоположение абонента', description: 'Определение местоположения абонента', icon: 'pi pi-map-marker', path: '/usrinf-v2' },
      ]
    },
    {
      title: 'PCRF Protei',
      items: [
        { label: 'Просмотр пакетов', description: 'Просмотр доступных пакетов PCRF', icon: 'pi pi-desktop', path: '/pcrf-protei-packages' },
        { label: 'Пакеты пользователя', description: 'Управление пакетами пользователей', icon: 'pi pi-user-plus', path: '/pcrf-protei-ordered-packages' },
        { label: 'Логи команд', description: 'Просмотр истории команд PCRF', icon: 'pi pi-database', path: '/pcrf-protei-logs' },
        { label: 'PCRF Protei Test', description: 'Тестовая среда PCRF Protei', icon: 'pi pi-cog', path: '/pcrf-protei-ordered-packages-test' },
        //{ label: 'PCRF Logs Huawei', description: 'Логи системы PCRF Huawei', icon: 'pi pi-server', path: '/pcrf-logs' },
      ]
    },
    {
      title: 'Summa Networks',
      items: [
        { label: 'Блокировка сетей', description: 'Управление блокировкой сетей ARD', icon: 'pi pi-ban', path: '/summa-ards' },
        { label: 'Переадресации', description: 'Настройка переадресаций вызовов', icon: 'pi pi-reply', path: '/summa-cfs' },
        { label: 'Регистрация абонента', description: 'Информация о регистрации абонентов', icon: 'pi pi-id-card', path: '/summa-sub-info' },
      ]
    },
  ];

  if (hasAccess('/temperature') || hasAccess('/stats-2g') || hasAccess('/stats-3g')) {
    menuCategories.push({
      title: 'Мониторинг и статистика',
      items: [
        ...(hasAccess('/temperature') ? [{ label: 'Температура БТС', description: 'Мониторинг температуры и влажности на БТС', icon: 'pi pi-sun', path: '/temperature' }] : []),
        ...(hasAccess('/stats-2g') ? [{ label: '2G Статистика', description: 'KPI показатели сети 2G', icon: 'pi pi-chart-bar', path: '/stats-2g' }] : []),
        ...(hasAccess('/stats-3g') ? [{ label: '3G Статистика', description: 'KPI показатели сети 3G', icon: 'pi pi-chart-line', path: '/stats-3g' }] : []),
      ]
    });
  }

  if (hasAccess('/mobigap-status') || hasAccess('/mobigap-fwd')) {
    menuCategories.push({
      title: 'Mobigap',
      items: [
        ...(hasAccess('/mobigap-status') ? [{ label: 'Проверка статуса', description: 'Проверка статуса номеров в Mobigap', icon: 'pi pi-search', path: '/mobigap-status' }] : []),
        ...(hasAccess('/mobigap-fwd') ? [{ label: 'Блокировка номеров', description: 'Блокировка и разблокировка номеров', icon: 'pi pi-lock', path: '/mobigap-fwd' }] : []),
      ]
    });
  }

  if (hasAccess('/staff') || isAdmin) {
    menuCategories.push({
      title: 'Администрирование',
      items: [
        ...(hasAccess('/staff') ? [{ label: 'Сотрудники', description: 'Управление персоналом и доступами', icon: 'pi pi-users', path: '/staff' }] : []),
        ...(isAdmin ? [{ label: 'Пользователи', description: 'Управление пользователями системы', icon: 'pi pi-user-edit', path: '/users' }] : []),
        ...(isAdmin ? [{ label: 'Создать пользователя', description: 'Регистрация нового пользователя системы', icon: 'pi pi-user-plus', path: '/signup' }] : []),
      ]
    });
  }

  let colorIndex = 0;

  return (
    <div className="p-5">
      {menuCategories.map((category, idx) => (
        <div key={idx} className="mb-5">
          <h2 className="text-center text-white font-bold text-2xl mb-2">{category.title}</h2>
          <Divider className="mb-4" style={{ borderColor: 'rgba(255,255,255,0.4)' }} />

          <div className="grid">
            {category.items.map((item, itemIdx) => {
              const palette = iconColors[colorIndex % iconColors.length];
              colorIndex++;
              return (
                <div key={itemIdx} className="col-12 md:col-6 lg:col-4 xl:col-3">
                  <Link
                    to={item.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="border-round-xl p-4 h-full cursor-pointer shadow-2 hover:shadow-6 transition-all transition-duration-300 block no-underline"
                    style={{ backgroundColor: '#ffffff' }}
                  >
                    <div
                      className="flex align-items-center justify-content-center border-round-lg mb-3"
                      style={{
                        width: '48px',
                        height: '48px',
                        backgroundColor: palette.bg,
                      }}
                    >
                      <i className={item.icon} style={{ fontSize: '1.25rem', color: palette.color }}></i>
                    </div>
                    <h3 className="text-lg font-bold mb-2 mt-0" style={{ color: '#1e293b' }}>{item.label}</h3>
                    <p className="m-0 text-sm line-height-3" style={{ color: '#64748b' }}>{item.description}</p>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Home;
